import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import userSupportService from '../../../../services/UserSupportService';
import { ResetDialogProps } from './UserLessonProgressTable';
import Alert from '@mui/material/Alert';

interface ResetLessonDialogProps {
  open: boolean;
  props?: ResetDialogProps;
  handleClose: () => void;
  setResetLesson: (lessonId: string, courseId: string) => void;
}
export default function ResetLessonDialog({
  open,
  props,
  handleClose,
  setResetLesson,
}: ResetLessonDialogProps) {
  const [saving, setSaving] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [updateResult, setUpdateResult] = useState<boolean | undefined>(
    undefined,
  );

  const onClose = () => {
    setUpdateResult(undefined);
    setDisabled(false);
    handleClose();
  };

  const handleResetLesson = async () => {
    if (props) {
      setSaving(true);
      const result = await userSupportService.resetLessonProgress(
        props.userAccountId,
        props.siteId,
        props.academicYearId,
        props.lessonId,
        props.courseId,
        props.languageCode,
      );
      setUpdateResult(result);
      if (result) {
        setResetLesson(props.lessonId, props.courseId);
      }
    }
    setSaving(false);
    setDisabled(true);
  };

  return (
    <Dialog
      aria-labelledby='reset-lesson-modal-title'
      aria-describedby='reset-lesson-description'
      open={open}
      scroll='body'
      onClose={onClose}
    >
      <DialogContent>
        <>
          <Typography variant='h4'>Reset Lesson</Typography>
          <Typography>
            You are about to reset "{props?.lessonName}" for this student.
            Please select “RESET” to move forward with this action.
          </Typography>
        </>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          color='primary'
          onClick={handleResetLesson}
          disabled={disabled}
        >
          {saving ? <CircularProgress color='primary' size='1rem' /> : 'Reset'}
        </Button>
        <Button
          variant='contained'
          color='secondary'
          onClick={onClose}
          disabled={saving}
        >
          Close
        </Button>
      </DialogActions>
      {updateResult !== undefined && (
        <Alert severity={updateResult ? 'success' : 'error'}>
          {updateResult
            ? 'Lesson reset successfully!'
            : 'Error Resetting Lesson. Please Try Again!'}
        </Alert>
      )}
    </Dialog>
  );
}
